"use strict";
'use client';
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var credit_card_type_1 = __importDefault(require("credit-card-type"));
var format_string_by_pattern_1 = __importDefault(require("format-string-by-pattern"));
var next_intl_1 = require("next-intl");
var react_1 = __importStar(require("react"));
var react_final_form_1 = require("react-final-form");
var InputText_1 = __importDefault(require("../../../InputText"));
var InputField_1 = __importDefault(require("../../InputField"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Cards = function (_a) {
    var method = _a.method, hideFieldsByInitialValues = _a.hideFieldsByInitialValues;
    var t = (0, next_intl_1.useTranslations)('translation');
    var fields = ((method === null || method === void 0 ? void 0 : method.requiredFields) || []).filter(function (f) { return f !== 'amount' && f !== 'country'; });
    var countries = (0, swr_hooks_1.useCountriesOptions)();
    var formState = (0, react_final_form_1.useFormState)();
    var data = (0, swr_hooks_1.useUser)().data;
    var getField = function (field) { return fields.find(function (f) { return f === field; }); };
    var cardNumber = getField('cardNumber');
    var expirationDate = getField('expirationDate');
    var cardMonth = getField('cardMonth');
    var cardYear = getField('cardYear');
    var cardHolder = getField('cardHolder');
    var firstName = getField('firstName');
    var lastName = getField('lastName');
    var country = getField('country');
    var city = getField('city');
    var phone = getField('phone');
    var state = getField('state');
    var address = getField('address');
    var zip = getField('zip');
    var email = getField('email');
    var isHideFieldsPart = (hideFieldsByInitialValues === null || hideFieldsByInitialValues === void 0 ? void 0 : hideFieldsByInitialValues.firstName) && (hideFieldsByInitialValues === null || hideFieldsByInitialValues === void 0 ? void 0 : hideFieldsByInitialValues.lastName);
    if (isHideFieldsPart)
        return null;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        cardNumber && (expirationDate || (cardMonth && cardYear)) ? (react_1.default.createElement("div", { className: styles_module_scss_1.default.rowPart },
            cardNumber && react_1.default.createElement(CardField, { field: cardNumber, mask: masks.card }),
            (expirationDate || (cardMonth && cardYear)) && (react_1.default.createElement(InputField_1.default, { field: expirationDate || 'expirationDate', mask: masks.expDate })))) : (cardNumber && react_1.default.createElement(CardField, { field: cardNumber, mask: masks.card })),
        cardHolder && react_1.default.createElement(InputField_1.default, { field: cardHolder }),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.fieldsContainer },
            firstName && react_1.default.createElement(InputField_1.default, { field: firstName }),
            lastName && react_1.default.createElement(InputField_1.default, { field: lastName }),
            country && (react_1.default.createElement(react_final_form_1.Field, { name: "country", render: function (_a) {
                    var _b;
                    var input = _a.input, meta = _a.meta;
                    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.fieldWrapper },
                        react_1.default.createElement(ui_components_1.InputSelect, __assign({}, input, { labelText: t('country'), options: countries, placeholder: t('selectCountry'), hasError: meta.error && meta.touched, isDisabled: false, helperButton: meta.error && meta.touched && { type: 'error' } })),
                        meta.error && meta.touched && (react_1.default.createElement(ui_components_1.ErrorText, null, (_b = meta.error) === null || _b === void 0 ? void 0 : _b.value))));
                } })),
            city && react_1.default.createElement(InputField_1.default, { field: city }),
            zip && (react_1.default.createElement("div", null,
                react_1.default.createElement(InputField_1.default, { field: zip }))),
            phone && (react_1.default.createElement(react_final_form_1.Field, { name: "phone", key: "withdrawalField_".concat(phone === null || phone === void 0 ? void 0 : phone.type), render: function (_a) {
                    var _b, _c, _d, _e, _f, _g, _h, _j;
                    var input = _a.input, meta = _a.meta;
                    return (react_1.default.createElement("div", { style: { gridColumn: '1 / -1' } },
                        react_1.default.createElement(ui_components_1.PhoneInput, __assign({}, input, { country: ((_d = (_c = (_b = formState === null || formState === void 0 ? void 0 : formState.values) === null || _b === void 0 ? void 0 : _b['country']) === null || _c === void 0 ? void 0 : _c.value) === null || _d === void 0 ? void 0 : _d.toLowerCase()) ||
                                ((_j = (_h = (_g = (_f = (_e = data === null || data === void 0 ? void 0 : data.profile) === null || _e === void 0 ? void 0 : _e.getOne) === null || _f === void 0 ? void 0 : _f.profile) === null || _g === void 0 ? void 0 : _g.location) === null || _h === void 0 ? void 0 : _h.country) === null || _j === void 0 ? void 0 : _j.toLowerCase()), placeholder: t('phone'), labelText: t('phone'), countryCodeEditable: true, helperButton: meta.error && meta.touched && { type: 'error' }, tooltip: react_1.default.createElement("div", { dangerouslySetInnerHTML: {
                                    __html: t.raw('lockPersonalData'),
                                } }) })),
                        meta.error && meta.touched && (react_1.default.createElement("div", { className: styles_module_scss_1.default.errorWrapper },
                            react_1.default.createElement(ui_components_1.ErrorText, null, meta.error)))));
                } })),
            state && (react_1.default.createElement("div", { style: { gridColumn: '1 / -1' } },
                react_1.default.createElement(InputField_1.default, { field: state }))),
            address && (react_1.default.createElement("div", { style: { gridColumn: '1 / -1' } },
                react_1.default.createElement(InputField_1.default, { field: address }))),
            email && (react_1.default.createElement("div", { style: { gridColumn: '1 / -1' } },
                react_1.default.createElement(InputField_1.default, { field: email }))))));
};
var masks = {
    card: '0000 0000 0000 0000',
    expDate: 'MM/YY',
};
var cardImages = [
    'visa',
    'mastercard',
    'unionpay',
    'american-express',
    'maestro',
    'mir',
    'jcb',
];
var CardField = function (_a) {
    var field = _a.field, _b = _a.mask, mask = _b === void 0 ? '' : _b;
    var t = (0, next_intl_1.useTranslations)('translation');
    var _c = (0, react_1.useState)(null), cardType = _c[0], setCardType = _c[1];
    var handleCardOnChange = function (e, onChange) {
        // For prevent using string in number field
        if (Number.isNaN(Number(e.target.value.replaceAll(' ', '')))) {
            return;
        }
        var type = (0, credit_card_type_1.default)(e.target.value)[0];
        if (e.target.value) {
            setCardType(type);
        }
        else {
            setCardType(null);
        }
        onChange(e);
    };
    return (react_1.default.createElement(react_final_form_1.Field, { name: field, key: "field_name_".concat(field), parse: mask ? (0, format_string_by_pattern_1.default)(mask) : function (v) { return v; } }, function (_a) {
        var input = _a.input, meta = _a.meta;
        return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.inputWrapper, " ").concat(styles_module_scss_1.default.cardField) },
            input.value &&
                cardType &&
                cardImages.includes((cardType === null || cardType === void 0 ? void 0 : cardType.type) || field) && (react_1.default.createElement("div", { className: styles_module_scss_1.default.cardType },
                react_1.default.createElement("img", { src: "/img/payments/methods/".concat((cardType === null || cardType === void 0 ? void 0 : cardType.type) || field, ".svg") }))),
            react_1.default.createElement(InputText_1.default, __assign({ labelText: t("".concat((field === null || field === void 0 ? void 0 : field.name) || 'customer.' + field, ".title")), id: field, placeholder: t("".concat((field === null || field === void 0 ? void 0 : field.name) || 'customer.' + field, ".placeholder")), type: field, helpertext: meta.error && meta.touched
                    ? { status: 'error', text: meta.error }
                    : undefined }, input, { onChange: function (e) { return handleCardOnChange(e, input.onChange); } }))));
    }));
};
exports.default = Cards;
